import React from 'react';
import Input from "components/form/Input";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import GModal from "components/ui/modal/Modal";
import GButton from "components/ui/button/Button";
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getQuantityAdjustmentFilteredData } from '../../services/quantityAdjustmentService';

export default function FilterModal({onClose , data }) {
    const { t } = useTranslation();
    const dispatch =useDispatch();
    const toast = useToast({position: "top", duration: 3000, status: "success", });

    const [filteredData, setFilteredData] = useState(data);

    // Filter Data
    const [filterCriteria, setFilterCriteria] = useState({
        BranchName: "",
        CostAdjustmentRef: "",
      });

      const handleFilterQuantityAdjustment = (e) => {
        e.preventDefault();
    
        const filteredResult = data.filter((item) => {
          const { BranchName , ReasonNameEng , Status } = filterCriteria;
    
          let filterBranchName = true;
          let filterReasonNameEng= true;
          let filterStatus = true;
    
          if (BranchName) {
            filterBranchName = item.BranchName.toLowerCase().includes(BranchName.toLowerCase());
          }
    
          if (ReasonNameEng) {
            filterReasonNameEng = item.ReasonNameEng.toLowerCase().includes(ReasonNameEng.toLowerCase());
          }
    
          if (Status) {
            filterStatus = item.Status.toLowerCase().includes(Status.toLowerCase());
          }

          return (
            filterBranchName &&
            filterReasonNameEng &&
            filterStatus 
          );

        });
    
        setFilteredData(filteredResult);
        onClose();
        dispatch(getQuantityAdjustmentFilteredData(filteredResult));
      };

  return <>
  
  <GModal
      onClose={onClose}
      modalHeader={t("pages.quantity_adjustment.quantity_adjustment_filter")}
      modalContent={
        <Box p={4}>
          <form 
            onSubmit={handleFilterQuantityAdjustment}
          >
            <Stack spacing={6}>
              <Input
                label={t("pages.quantity_adjustment.branch_name")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.quantity_adjustment.branch_name")}
                name="BranchName"
                value={filterCriteria.BranchName}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    BranchName: e.target.value,
                  })
                }
              />
              <Input
                label={t("pages.quantity_adjustment.reason_name")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.quantity_adjustment.reason_name")}
                name="ReasonNameEng"
                value={filterCriteria.ReasonNameEng}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    ReasonNameEng : e.target.value,
                  })
                }
              />

              {/* <Input
                label={t("pages.quantity_adjustment.status")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.quantity_adjustment.status")}
                name="Status"
                value={filterCriteria.Status}
                onChange={(e) =>
                  setFilterCriteria({
                    ...filterCriteria,
                    Status: e.target.value,
                  })
                }
              /> */}

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  
  </>
}
